import LocalizedStrings from 'localized-strings';

import { LockedReason } from '__generated__/GQL';

const locales = new LocalizedStrings({
  en: {
    title: 'The access to your features has been modified',
    [LockedReason.AccountClosureRequest]:
      'Some of your account features are suspended because you requested the closure of your account.',
    [LockedReason.UndeliveredCard]:
      'Your Shine card could not be delivered to the address you provided. We have suspended some of the functionality of your account until your dossier is updated. We invite you to contact our team to regularize the situation.',
    [LockedReason.CompanySituationUpdate]:
      'We had to temporarily suspend some of Shine’s features while we update the information on your company',
    [LockedReason.Custom]: 'We had to lock some features of the app: {0}',
    [LockedReason.FraudInvestigation]:
      'We had to temporarily suspend some of Shine’s features while we make some security checks.',
    [LockedReason.MissingInformation]:
      'We had to suspend some features on your account because we are waiting for a document from you.\n\n' +
      'We invite you to contact our team to update your dossier. You will then be able to use your account as usual.',
    [LockedReason.TakeoverAttempt]:
      'We suspect an intrusion into your account. We are investigating on it for your security.',
  },
  fr: {
    title: 'L’accès à vos fonctionnalités a été modifié',
    [LockedReason.AccountClosureRequest]:
      'Certaines fonctionnalités de votre compte sont suspendues car vous avez demandé la clôture de votre compte.',
    [LockedReason.UndeliveredCard]:
      'Votre carte Shine n’a pas pu être livrée à l’adresse que vous avez renseignée. Nous avons suspendu certaines fonctionnalités de votre compte en attendant que votre dossier soit mis à jour. Nous vous invitons à prendre contact avec notre équipe pour régulariser la situation.',
    [LockedReason.CompanySituationUpdate]:
      'Nous avons dû suspendre certaines fonctionnalités de Shine le temps de modifier les informations de votre entreprise.',
    [LockedReason.Custom]:
      'Nous avons dû suspendre certaines fonctionnalités de Shine : {0}',
    [LockedReason.FraudInvestigation]:
      'Nous avons dû suspendre certaines fonctionnalités de Shine le temps d’effectuer quelques vérifications.',
    [LockedReason.MissingInformation]:
      'Nous avons dû suspendre certaines fonctionnalités sur votre compte car nous sommes dans l’attente d’un document de votre part.\n\n' +
      'Nous vous invitons à contacter notre équipe pour mettre à jour votre dossier. Vous pourrez ensuite utiliser votre compte normalement.',
    [LockedReason.TakeoverAttempt]:
      'Nous suspectons une intrusion sur votre compte. Nous enquêtons pour votre sécurité.',
  },
});

export default locales;
